


















import { Component, Vue } from 'vue-property-decorator'
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('photos')

@Component({
  computed: mapState([
    'isSignedIn'
  ])
})
export default class Login extends Vue {
  readonly isSignedIn!: boolean|null;

  login () {
    this.$gapi.login()
  }

  logout () {
    this.$gapi.logout()
  }
}
